import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const COMOREGISTRATIONMODAL_LEGACY_FIELD_ORDER = [
  { type: 'heading', value: "Comportement" },
  "go_to_u_r_l_on_close",
  "go_to_kiosk_register",
  {
    type: 'messageUtil',
    options: {
      type: 'info',
      padding: true,
      message:
        "Mode kiosk : après le numéro Como, affiche une modale de confirmation (ex. « Bienvenue … ») pour indiquer que le client est connecté, puis redirige vers l’URL ci-dessus. Désactivé : la redirection peut être immédiate après le téléphone, sans écran de confirmation (selon le plugin Como). Sur une borne, laissez activé et choisissez une URL en mode Page, pas un lien vers un autre modal.",
    },
  },
  "active_step",
  { type: 'heading', value: "Couleurs" },
  "background_color",
  "accent_font_color",
  "accent_background_color",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  comoRegistrationModalDescriptor: _generatedComoRegistrationModalDescriptor,
  comoRegistrationModalModalDefinition,
  comoRegistrationModalDashboardLayout,
  comoRegistrationModalConfig,
  comoRegistrationModalResolveConfig,
  comoRegistrationModalProperties,
} = doodModalConfig(
  {
    name: "Como - Registration modal",
    handle: "como-registration-modal",
    internal_name: "ComoRegistrationModal",
    componentType: 'ComoRegistrationModalComponent',
    category: 'modal',
    description: "Como - Registration modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "como-registration-modal",
    allowed_in: ["ModalBlock"],
    sharedFields: {}
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        "label": "Couleur de fond"
      }
    }),
    go_to_u_r_l_on_close: propertyValue({
      type: 'link',
      value: '',
      options: {
        "label": "URL de redirection à la fermeture",
        "help": "Page ou route interne après fermeture. Laisser vide pour ne pas rediriger.",
        "defaultMode": "page",
        "modes": [
          "page",
          "navigationBack",
        ],
      }
    }),
    go_to_kiosk_register: propertyValue({
      type: 'checkbox',
      value: false,
      description:
        "Parcours borne : après identification Como, modale de confirmation (bienvenue + prénom) puis redirection. Désactivé : redirection possible tout de suite après le téléphone, sans confirmation.",
      options: {
        "label": "Mode kiosk",
        "help": "Affiche la confirmation de connexion avant la redirection (recommandé en kiosk)."
      }
    }),
    active_step: propertyValue({
      type: 'select',
      value: "STEP_PHONE",
      options: {
        "label": "Étape initiale",
        "choices": [
          {
            "value": "STEP_PHONE",
            "label": "Téléphone"
          },
          {
            "value": "STEP_OTP",
            "label": "Code OTP"
          },
          {
            "value": "STEP_AUTHENTICATION",
            "label": "Authentification"
          },
          {
            "value": "STEP_ACCOUNT_NOT_FOUND",
            "label": "Compte introuvable"
          },
          {
            "value": "STEP_KIOSK_CONFIRMATION",
            "label": "Kiosk — confirmation"
          },
          {
            "value": "STEP_KIOSK_REGISTER",
            "label": "Kiosk — inscription"
          },
          {
            "value": "STEP_KIOSK_REGISTER_CONFIRMATION",
            "label": "Kiosk — confirmation inscription"
          },
          {
            "value": "STEP_KIOSK_ACCOUNT_NOT_FOUND",
            "label": "Kiosk — compte introuvable"
          }
        ]
      }
    }),
    accent_font_color: propertyValue({
      type: 'color',
      value: { type: 'default', value: '' },
      options: {
        label: "Couleur d'accent — texte",
      },
    }),
    accent_background_color: propertyValue({
      type: 'color',
      value: { type: 'default', value: '' },
      options: {
        label: "Couleur d'accent — fond",
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: [
              "background_color",
              "go_to_u_r_l_on_close",
              {
                prop: "go_to_kiosk_register",
                label: "Mode kiosk",
                help:
                  "Parcours borne : après le numéro Como, une modale confirme que le client est connecté (message de bienvenue avec le prénom), puis redirection vers l’URL ci-dessus. Désactivé : la redirection peut se faire immédiatement après le téléphone, sans cet écran (souvent le cas si le plugin Como autorise les utilisateurs anonymes). Recommandé sur kiosk ; URL de redirection en mode Page, jamais un lien vers un autre modal.",
              },
              "active_step",
              "accent_font_color",
              "accent_background_color",
            ],
          },
        ],
      },
    ],
  })
);

export function comoRegistrationModalDescriptor(): IBlockDescriptor;
export function comoRegistrationModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function comoRegistrationModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedComoRegistrationModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedComoRegistrationModalDescriptor, comoRegistrationModalProperties, fieldOrder);
}

export {
  comoRegistrationModalModalDefinition,
  comoRegistrationModalDashboardLayout,
  comoRegistrationModalProperties,
  comoRegistrationModalConfig,
  comoRegistrationModalResolveConfig,
};

export type ComoRegistrationModalConfig = typeof comoRegistrationModalConfig;
